module.exports = __webpack_public_path__ + "static/media/81.492dfd6e.mp3";